import React from "react";
import "./footer.css";
function Footer() {
  return <div className="footer">Efe_Roy, 2022</div>;
}

export default Footer;